import {FormLabel, FormRow} from '@dropbox/dig-components/form_row';
import {Menu} from '@dropbox/dig-components/menu';
import {Box, Stack} from '@dropbox/dig-foundations';
import {
  EmployeeLdap,
  TeamWithCounts,
  WorkstreamEdit,
  WorkstreamEmployeeEdit,
  WorkstreamPrivacy,
} from 'client';
import {t} from 'i18next';
import {Suspense} from 'react';

import {
  WorkstreamPrivacyActionItem,
  WorkstreamPrivacyCustomAccessory,
} from './WorkstreamPrivacyMenu';

export const WorkstreamSettingsDrawer = ({
  workstream,
  // setStatusDue,
  onPrivacyChange,
  owners,
  privateEmployees,
  privateTeams,
}: {
  workstream: WorkstreamEdit;
  // setStatusDue: (statusDue: number) => void;
  onPrivacyChange: (privacy: WorkstreamPrivacy) => void;
  owners: WorkstreamEmployeeEdit[];
  privateEmployees: EmployeeLdap[];
  privateTeams: TeamWithCounts[];
}) => {
  return (
    <Box>
      {/* <FormRow>
        <FormLabel>{t('workstream_due_day')}</FormLabel>

        <Split gap="8">
          {Array.from({length: 5}).map((_, i) => (
            <Split.Item key={i + 1} width="fill">
              <Box
                onClick={() => setStatusDue(i + 1)}
                cursor="pointer"
                paddingX="8"
                paddingY="12"
                borderRadius="Medium"
                textAlign="center"
                borderStyle="Solid"
                borderColor={workstream.status_due === i + 1 ? 'transparent' : 'Border Subtle'}
                backgroundColor={workstream.status_due === i + 1 ? 'Opacity Surface' : undefined}
                {...withShade({})}
              >
                <Text isBold={workstream.status_due === i + 1}>
                  {getI18nDayName(i + 1).slice(0, 3)}
                </Text>
              </Box>
            </Split.Item>
          ))}
        </Split>
      </FormRow> */}

      <FormRow>
        <FormLabel>{t('workstream_privacy')}</FormLabel>

        <Menu.Wrapper
          closeOnSelection={false}
          onSelection={(value) => onPrivacyChange(value)}
          style={{display: 'flex'}}
        >
          {() => (
            <Stack gap="8">
              <WorkstreamPrivacyActionItem
                value={WorkstreamPrivacy.PUBLIC}
                workstream={workstream}
              />
              <WorkstreamPrivacyActionItem
                value={WorkstreamPrivacy.PRIVATE}
                workstream={workstream}
              />
              <Suspense>
                <WorkstreamPrivacyActionItem
                  value={WorkstreamPrivacy.CUSTOM}
                  workstream={{
                    ...workstream,
                    employee_associations: owners,
                    private_employees: privateEmployees.map(({user_id}) => user_id),
                    private_teams: privateTeams.map(({team_id}) => team_id),
                  }}
                  rightAccessory={<WorkstreamPrivacyCustomAccessory />}
                />
              </Suspense>
            </Stack>
          )}
        </Menu.Wrapper>
      </FormRow>
    </Box>
  );
};
